import React, { useState, useEffect, useCallback, useImperativeHandle, forwardRef } from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { useDropzone } from 'react-dropzone';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Select, FormControl, InputLabel, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { createTheme as createThemeV4, ThemeProvider as ThemeProviderV4 } from '@material-ui/core/styles';
import CssBaselineV4 from '@material-ui/core/CssBaseline';
import { Checkbox, FormControlLabel } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import { returnDescricaoInsumo as returnDescricaoInsumoGlobal }
    from '../../../../../utils/insumoHelpers';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Paper } from '@mui/material';
import CadastrarNovoItemPreCotacaoStandalone from './adicionarItem.js';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Collapse from '@mui/material/Collapse';

import { styled } from '@material-ui/styles';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Delete } from '@material-ui/icons';
import { parse, format } from 'date-fns';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import api from '../../../../../services/api';
import { Card, CardContent } from '@mui/material';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../assets/imgs/office.png';
import EditarCotacao from '../../../../../pages/painelAdmin/AreaGestao/ModuloOperacional/ModuloAlmoxarifado/Cotacoes/editar.js';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {
    DataGrid, ptBR,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';



const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));



const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'green',
        borderColor: 'green',
    },
}));



//export default function EditarPreCotacao({ ref, flag = 0, fornecedorJaSelecionado, vendedorJaSelecionado }) {
const EditarPreCotacao = forwardRef(({ dataInformada, flag = 0, fornecedorJaSelecionado, vendedorJaSelecionado }, ref) => {

    const linhaNovaPadrao = {
        id_item_ordem_compra: 0,
        quantidade: '',
        cotacao: {
            codigo_interno_fornecedor: '',
            unidade: '',
            valor_unitario: 0,
            valor_desconto: 0,
        },
        insumo: {
            descricao: '',
            variacoes: []
        },
    };


    const regra = Cookies.get("regra") || "";

    const [freteAParte, setFreteAParte] = useState(false);

    const [modalidadeCondicao, setModalidadeCondicao] = useState(0);
    const [numeroParcelas, setNumeroParcelas] = useState(0);
    const [tipoIntervalo, setTipoIntervalo] = useState(0);
    const [intervaloPrimeiraParcela, setIntervaloPrimeiraParcela] = useState(1);


    const [intervaloParcelas, setIntervaloParcelas] = useState(0);
    const [intervaloVariavel, setIntervaloVariavel] = useState('');

    const [tipoDivisao, setTipoDivisao] = useState(0);
    const [divisaoVariavel, setDivisaoVariavel] = useState('');

    const [parcelasSimuladas, setParcelasSimuladas] = useState([]);
    const [tipoValor, setTipoValor] = useState("total");
    const [repetirData, setRepetirData] = useState(false);

    const [isDark, setIsDark] = useState(Cookies.get('darkMode') === 'true');

    useEffect(() => {
        const interval = setInterval(() => {
            const currentDarkMode = Cookies.get('darkMode') === 'true';
            if (currentDarkMode !== isDark) {
                setIsDark(currentDarkMode);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [isDark]);

    const theme = createTheme({
        palette: {
            mode: isDark ? 'dark' : 'light',
            background: {
                default: isDark ? '#121212' : '#ffffff',
                paper: isDark ? '#1e1e1e' : '#ffffff',
            },
        },
    });

    const themeV4 = createThemeV4({
        palette: {
            type: isDark ? 'dark' : 'light',
        },
    });

    const dropzoneStyles = {
        border: isDark ? '4px dashed #ffffff' : '4px dashed #000000',
        borderRadius: '4px',
        padding: '2px',
        textAlign: 'center',
        cursor: 'pointer',
        margin: '2px 0',
        color: isDark ? 'white' : 'black'
    };


    // estados com valor inicial baseado em flag
    const [fornecedorSelecionado, setFornecedorSelecionado] = useState(
        flag === 1 ? fornecedorJaSelecionado : null
    );

    const [vendedorSelecionado, setVendedorSelecionado] = useState(
        flag === 1 ? vendedorJaSelecionado : null
    );

    // Atualiza estados caso props mudem depois
    useEffect(() => {
        if (flag === 1) {
            setFornecedorSelecionado(fornecedorJaSelecionado);
            setVendedorSelecionado(vendedorJaSelecionado);
        }
    }, [flag, fornecedorJaSelecionado, vendedorJaSelecionado]);


    const onDropArquivo1 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('application/pdf') && !acceptedFiles[0].type.includes('application/vnd.openxmlformats-officedocument')) {
            alert('Apenas arquivos PDF ou do Office são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setOpenAtualizando(true);
        try {
            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

            const response = await api.post('/v1/protected/ordemcompras/anexararquivoprecotacao/' + idOrdemCompra + "/" + idPreCotacao, formData);

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {

                setPreCotacao(response.data);

            } else {
                // Lógica a ser executada caso ocorra algum erro durante o salvamento
            }
            setOpenAtualizando(false);
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setOpenAtualizando(false);
        }
    }, []);


    const [tabelaKey, setTabelaKey] = useState(0);


    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });


    const history = useHistory();

    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });


    const { idOrdemCompra } = useParams();
    const { idPreCotacao } = useParams();
    const [openAtualizando, setOpenAtualizando] = useState(false);

    const [itens, setItens] = useState([]);
    const [valorFrete, setValorFrete] = useState(0);
    const [observacoes, setObservacoes] = useState("");
    const [dataEntrega, setDataEntrega] = useState("");
    const [valorDescontoGeral, setValorDescontoGeral] = useState(0);


    const [diasPrevistaEntrega, setDiasPrevistaEntrega] = useState("");

    const [loading, setLoading] = useState(true);

    const [ordemCompra, setOrdemCompra] = useState(null);
    const [preCotacao, setPreCotacao] = useState(null);

    const [metodosPagamento, setMetodosPagamento] = useState([]);


    const [metodosPagamentosSelecionados, setMetodosPagamentosSelecionados] = useState([]);

    const [condicoesPagamento, setCondicoesPagamento] = useState([]);
    const [condicaoPagamentoSelecionada, setCondicaoPagamentoSelecionada] = useState(null);

    const [contaBancariaSelecionada, setContaBancariaSelecionada] = useState(null);

    const [parametrosValores, setParametrosValores] = useState(
        {
            valorTotalItens: 0.0,
            valorTotalIpi: 0.0,
            valorTotalIcms: 0.0,
            valorTotalFrete: 0.0,
            valorDescontoGeral: 0.0,
            valorTotal: 0.0,
            valorTotalDescontos: 0.0,
            valorTotalItensComDescontos: 0.0,
        }
    );


    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            if (flag === 0) {
                await api.get("v1/protected/ordensdecompras/ordemdecompra/precotacao/listarporid/" + idPreCotacao, {
                    headers: headers
                }).then(function (response) {

                    setPreCotacao(response.data);
                    setFornecedorSelecionado(response.data.fornecedor);
                    setObservacoes(response.data.observacoes);
                    setValorFrete(response.data.valor_frete);
                    setValorDescontoGeral(response.data.valor_desconto_geral);
                    setFreteAParte(response.data.frete_a_parte === 1 ? true : false);

                    setMetodosPagamentosSelecionados(response.data.metodos_pagamento);
                    setCondicaoPagamentoSelecionada(response.data.condicao_pagamento);

                    //atributos financeiros

                    setModalidadeCondicao(response.data.modalidade_condicao);
                    setNumeroParcelas(response.data.numero_parcelas);
                    setTipoIntervalo(response.data.tipo_intervalo);
                    setIntervaloPrimeiraParcela(response.data.intervalo_primeira_parcela);


                    setIntervaloParcelas(response.data.intervalo_parcelas);
                    setIntervaloVariavel(response.data.intervalo_variavel);
                    setTipoDivisao(response.data.tipo_divisao);
                    setDivisaoVariavel(response.data.divisao_variavel);
                    // setItens(response.data.itens_pre_cotacao);

                    setContaBancariaSelecionada(response.data.conta_bancaria);


                    // Ordenar
                    const itensOrdenados = response.data.itens_pre_cotacao.sort((a, b) => {
                        const descA = a?.insumo?.descricao?.toLowerCase() || '';
                        const descB = b?.insumo?.descricao?.toLowerCase() || '';
                        return descA.localeCompare(descB);
                    });



                    setItens(itensOrdenados);

                    setDataEntrega(new Date(response.data.data_prevista_entrega).toLocaleDateString('pt-BR'));

                    setDiasPrevistaEntrega(response.data.dias_prevista_entrega);

                    setVendedorSelecionado(response.data.vendedor);

                    let valor_total_itens = 0;
                    let valor_total_ipi = 0;
                    let valor_total_icms = 0;
                    let valor_total_itens_com_descontos = 0;
                    let valor_total_descontos = 0;

                    response.data.itens_pre_cotacao.forEach(item => {
                        if (item.cotacao && item.cotacao.valor_unitario && item.quantidade) {
                            valor_total_itens += (item.cotacao.valor_unitario) * item.quantidade;
                            valor_total_itens_com_descontos += (item.cotacao.valor_unitario - item.cotacao.valor_desconto) * item.quantidade;
                            valor_total_ipi += item.cotacao.valor_ipi;
                            valor_total_icms += item.cotacao.valor_icms;
                            valor_total_descontos += item.cotacao.valor_desconto * item.quantidade;

                        }
                    });

                    setParametrosValores(prevState => ({ ...prevState, 'valorTotalItens': valor_total_itens }))
                    setParametrosValores(prevState => ({ ...prevState, 'valorTotalIpi': valor_total_ipi }))
                    setParametrosValores(prevState => ({ ...prevState, 'valorTotalIcms': valor_total_icms }))
                    setParametrosValores(prevState => ({ ...prevState, 'valorTotalDescontos': valor_total_descontos }))
                    setParametrosValores(prevState => ({ ...prevState, 'valorTotalItensComDescontos': valor_total_itens_com_descontos }))
                    setParametrosValores(prevState => ({ ...prevState, 'valorDescontoGeral': response.data.valor_desconto_geral }))

                    setParametrosValores(prevState => ({
                        ...prevState,
                        'valorTotal': (valor_total_itens_com_descontos + valor_total_ipi + valor_total_icms + response.data.valor_frete - response.data.valor_desconto_geral)

                    }))

                    api.get("/v1/protected/ordensdecompras/ordemdecompra/listarporid/" + idOrdemCompra, {
                        headers: headers
                    }).then(function (response) {

                        const ordem_compra = response.data.ordem_compra;
                        setOrdemCompra(ordem_compra);

                        api.get("v1/protected/financeiro/metodospagamento/listartodos", {
                            headers: headers
                        }).then(function (response) {

                            setMetodosPagamento(response.data)


                            api.get("v1/protected/financeiro/condicoespagamento/listartodos", {
                                headers: headers
                            }).then(function (response) {

                                setCondicoesPagamento(response.data)
                                setLoading(false);

                            });


                        });

                    });


                });
            }
            else if (flag === 1) {
                await api.get("v1/protected/financeiro/metodospagamento/listartodos", {
                    headers: headers
                }).then(function (response) {

                    setMetodosPagamento(response.data)


                    api.get("v1/protected/financeiro/condicoespagamento/listartodos", {
                        headers: headers
                    }).then(function (response) {

                        setCondicoesPagamento(response.data)
                        setLoading(false);

                    });


                });

            }



        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }


    async function recalcular() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("v1/protected/ordensdecompras/ordemdecompra/precotacao/listarporid/" + idPreCotacao, {
                headers: headers
            }).then(function (response) {

                const itensOrdenados = response.data.itens_pre_cotacao.sort((a, b) => {
                    const descA = a?.insumo?.descricao?.toLowerCase() || '';
                    const descB = b?.insumo?.descricao?.toLowerCase() || '';
                    return descA.localeCompare(descB);
                });



                //setItens(itensOrdenados);
                setItens([...itensOrdenados]);
                setTabelaKey(prev => prev + 1);
                let valor_total_itens = 0;
                let valor_total_ipi = 0;
                let valor_total_icms = 0;
                let valot_total_descontos = 0;
                let valor_total_itens_com_descontos = 0;

                response.data.itens_pre_cotacao.forEach(item => {
                    if (item.cotacao) {
                        const valor_unitario = Number(item.cotacao.valor_unitario) || 0;
                        const valor_desconto = Number(item.cotacao.valor_desconto) || 0;
                        const quantidade = Number(item.quantidade) || 0;
                        const valor_ipi = Number(item.cotacao.valor_ipi) || 0;
                        const valor_icms = Number(item.cotacao.valor_icms) || 0;

                        valor_total_itens += valor_unitario * quantidade;
                        valot_total_descontos += valor_desconto * quantidade;
                        valor_total_ipi += valor_ipi;
                        valor_total_icms += valor_icms;
                        valor_total_itens_com_descontos += (valor_unitario - valor_desconto) * quantidade;
                    }
                });

                setParametrosValores(prevState => ({ ...prevState, 'valorTotalDescontos': valot_total_descontos }))

                setParametrosValores(prevState => ({ ...prevState, 'valorTotalItens': valor_total_itens }))
                setParametrosValores(prevState => ({ ...prevState, 'valorTotalIpi': valor_total_ipi }))
                setParametrosValores(prevState => ({ ...prevState, 'valorTotalIcms': valor_total_icms }))
                setParametrosValores(prevState => ({ ...prevState, 'valorTotalItensComDescontos': valor_total_itens_com_descontos }))

                setParametrosValores(prevState => ({
                    ...prevState,
                    'valorTotal': (valor_total_itens_com_descontos + valor_total_ipi + valor_total_icms + response.data.valor_frete - valorDescontoGeral)

                }))
            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }

    const [aberto, setAberto] = useState(false);


    async function recalcularStandAlone(novosItensParam) {
        try {
            // Usa o parâmetro se vier, senão usa o estado atual "itens"
            const listaAtual = Array.isArray(novosItensParam) ? novosItensParam : itens;

            // Garante que é um array antes de ordenar
            const itensOrdenados = [...listaAtual].sort((a, b) => {
                const descA = a?.insumo?.descricao?.toLowerCase() || '';
                const descB = b?.insumo?.descricao?.toLowerCase() || '';
                return descA.localeCompare(descB);
            });

            // Atualiza tabela
            setItens(itensOrdenados);
            setTabelaKey(prev => prev + 1);

            // Totais
            let valor_total_itens = 0;
            let valor_total_ipi = 0;
            let valor_total_icms = 0;
            let valot_total_descontos = 0;
            let valor_total_itens_com_descontos = 0;

            itensOrdenados.forEach(item => {
                if (item.cotacao) {
                    const valor_unitario = Number(item.cotacao.valor_unitario) || 0;
                    const valor_desconto = Number(item.cotacao.valor_desconto) || 0;
                    const quantidade = Number(item.quantidade) || 0;
                    const valor_ipi = Number(item.cotacao.valor_ipi) || 0;
                    const valor_icms = Number(item.cotacao.valor_icms) || 0;

                    valor_total_itens += valor_unitario * quantidade;
                    valot_total_descontos += valor_desconto * quantidade;
                    valor_total_ipi += valor_ipi;
                    valor_total_icms += valor_icms;
                    valor_total_itens_com_descontos += (valor_unitario - valor_desconto) * quantidade;
                }
            });

            // Atualiza os estados de totais
            setParametrosValores(prev => ({
                ...prev,
                valorTotalDescontos: valot_total_descontos,
                valorTotalItens: valor_total_itens,
                valorTotalIpi: valor_total_ipi,
                valorTotalIcms: valor_total_icms,
                valorTotalItensComDescontos: valor_total_itens_com_descontos,
                valorTotal: (valor_total_itens_com_descontos + valor_total_ipi + valor_total_icms + valorFrete - valorDescontoGeral)
            }));

        } catch (err) {
            console.log("Erro ao recalcular: ", err);
        }
    }

    const gerarSimulacaoPagamento = useCallback(() => {
        const valorTotal = parametrosValores.valorTotal;
        if (!valorTotal || isNaN(valorTotal) || Number(valorTotal) <= 0) {
            setParcelasSimuladas([]);
            return;
        }

        if (tipoIntervalo === 0) { // fixo
            if (!numeroParcelas || numeroParcelas <= 0) {
                setParcelasSimuladas([]);
                return;
            }
            if (!intervaloPrimeiraParcela && intervaloPrimeiraParcela !== 0) {
                setParcelasSimuladas([]);
                return;
            }
        } else if (tipoIntervalo === 1) { // variável
            if (!intervaloVariavel) {
                setParcelasSimuladas([]);
                return;
            }
        }

        if (tipoDivisao === 1 && !divisaoVariavel) {
            setParcelasSimuladas([]);
            return;
        }

        let novasParcelas = [];
        let hoje = new Date();
        let dataPrimeira;

        if (/^\d{2}\/\d{2}\/\d{4}$/.test(intervaloPrimeiraParcela)) {
            let [d, m, a] = intervaloPrimeiraParcela.split("/");
            dataPrimeira = new Date(`${a}-${m}-${d}T00:00:00`);
        } else {
            dataPrimeira = new Date(hoje);
            dataPrimeira.setDate(dataPrimeira.getDate() + Number(intervaloPrimeiraParcela || 0));
        }

        function adicionarParcela(venc, valor) {
            let parcela = {
                data_vencimento: venc.toLocaleDateString("pt-BR"),
                valor: Number(valor),
            };
            if (metodosPagamentosSelecionados && metodosPagamentosSelecionados.length > 0) {
                parcela.metodo_pagamento = metodosPagamentosSelecionados[0];
            }
            novasParcelas.push(parcela);
        }

        if (tipoIntervalo === 0) { // FIXO
            const usarRepeticaoDia = repetirData === true &&
                Number(intervaloPrimeiraParcela) >= 0 &&
                Number(intervaloPrimeiraParcela) <= 31 &&
                Number(intervaloParcelas) > 0;

            if (tipoValor === "parcela") {
                for (let i = 0; i < numeroParcelas; i++) {
                    let venc = new Date(dataPrimeira);
                    if (usarRepeticaoDia) {
                        let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
                        venc.setMonth(venc.getMonth() + meses);
                        venc.setDate(Number(intervaloPrimeiraParcela));
                    } else {
                        venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                    }
                    adicionarParcela(venc, Number(valorTotal));
                }
            } else if (tipoValor === "total") {
                if (tipoDivisao === 0) {
                    let valorParcela = (Number(valorTotal) / numeroParcelas).toFixed(2);
                    for (let i = 0; i < numeroParcelas; i++) {
                        let venc = new Date(dataPrimeira);
                        if (usarRepeticaoDia) {
                            let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
                            venc.setMonth(venc.getMonth() + meses);
                            venc.setDate(Number(intervaloPrimeiraParcela));
                        } else {
                            venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                        }
                        adicionarParcela(venc, valorParcela);
                    }
                } else {
                    let valores = divisaoVariavel.split(",").map(v => Number(v.trim()));
                    let soma = valores.reduce((a, b) => a + b, 0);
                    let usarPercentual = Math.abs(soma - 100) < 0.01;
                    for (let i = 0; i < valores.length; i++) {
                        let venc = new Date(dataPrimeira);
                        if (usarRepeticaoDia) {
                            let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
                            venc.setMonth(venc.getMonth() + meses);
                            venc.setDate(Number(intervaloPrimeiraParcela));
                        } else {
                            venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                        }
                        let valor = usarPercentual ? ((valores[i] / 100) * Number(valorTotal)).toFixed(2) : valores[i];
                        adicionarParcela(venc, valor);
                    }
                }
            }
        } else if (tipoIntervalo === 1) { // VARIÁVEL
            let intervalos = intervaloVariavel.split(",").map(v => Number(v.trim()));
            if (tipoDivisao === 0) {
                let valorParcela = (Number(valorTotal) / (intervalos.length || 1)).toFixed(2);
                let dataAtual = new Date(dataPrimeira);
                for (let i = 0; i < intervalos.length; i++) {
                    dataAtual.setDate(dataAtual.getDate() + intervalos[i]);
                    adicionarParcela(new Date(dataAtual), valorParcela);
                }
            } else {
                let valores = divisaoVariavel.split(",").map(v => Number(v.trim()));
                let soma = valores.reduce((a, b) => a + b, 0);
                let usarPercentual = Math.abs(soma - 100) < 0.01;
                let dataAtual = new Date(dataPrimeira);
                for (let i = 0; i < valores.length; i++) {
                    dataAtual.setDate(dataAtual.getDate() + (intervalos[i] || 0));
                    let valor = usarPercentual ? ((valores[i] / 100) * Number(valorTotal)).toFixed(2) : valores[i];
                    adicionarParcela(new Date(dataAtual), valor);
                }
            }
        }
        setParcelasSimuladas(novasParcelas);
    }, [parametrosValores.valorTotal, numeroParcelas, tipoIntervalo, intervaloParcelas, intervaloVariavel, intervaloPrimeiraParcela, tipoDivisao, divisaoVariavel, tipoValor, repetirData, metodosPagamentosSelecionados]);

    useEffect(() => {
        gerarSimulacaoPagamento();
    }, [gerarSimulacaoPagamento]);


    useEffect(() => {


        listarInformacoes();


    }, []);




    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    const [openEditarCotacao, setOpenEditarCotacao] = useState(false);
    const [cotacaoEditar, setCotacaoEditar] = useState(null);

    function returnDescricaoFornecedor(fornecedor) {

        var identificacao = fornecedor.tipo_fornecedor === 0 ? "CPF " : "CNPJ;"

        var valor = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;

        var nome = fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) :
            (fornecedor.nome_fantasia);

        var endereco = fornecedor.logradouro + ", nº " + fornecedor.numero + ", " + fornecedor.bairro + ", " + fornecedor.cidade + " " + fornecedor.estado + " CEP: " + fornecedor.cep;


        // var texto = "ID: " + fornecedor.id_fornecedor + "\n" + identificacao + " " + valor + "\n " + nome + "\n Endereço: " + endereco;
        var texto = nome + " | " + valor;
        texto += (fornecedor.tipo_loja === 0 ? "\nLoja Local" : "\nLoja Online");
        texto += (fornecedor.recebe_ordens === 0 ? "\nNão Recebe Ordens de Compra" : "\nRecebe Ordens de Compra");

        return texto;
    }



    function returnDescricaoContato(contato) {



        var texto = contato.cargo_contato + " " + contato.nome_contato;
        texto += "\nContato: " + contato.celular_contato;

        texto += (contato.whatsapp === 0 ? "" : "(Whatsapp)");

        if (contato.fixo)
            texto += "\nFixo: " + contato.fixo_contato;
        if (contato.e_mail_contato)
            texto += "\nE-mail: " + contato.e_mail_contato;
        texto += (contato.recebe_ordens === 0 ? "\nNão Recebe Ordens de Compra" : "\nRecebe Ordens de Compra");
        if (contato.descricao_contato)
            texto += "\nDescrição: " + contato.descricao_contato;


        return texto;
    }



    async function atualizar(idOrdemC = 0) {


        try {

            // ✅ Validações antes de enviar
            if (!metodosPagamentosSelecionados || metodosPagamentosSelecionados.length === 0) {
                alert("Selecione o método de pagamento.");
                return;
            }

            if (!numeroParcelas || parseInt(numeroParcelas) <= 0) {
                alert("O número de parcelas deve ser maior que zero.");
                return;
            }

            const exigeContaBancaria = metodosPagamentosSelecionados.some(
                metodo => metodo.id_metodo_pagamento === 1 || metodo.id_metodo_pagamento === 2
            );

            if (exigeContaBancaria) {
                if (!contaBancariaSelecionada || contaBancariaSelecionada === "") {
                    alert("Selecione uma conta bancária para o método de pagamento escolhido");
                    return;
                }
            }

            console.log("cadastrar chamado");
            const cadastro = {

                observacoes: observacoes,
                valor_frete: valorFrete,
                dias_prevista_entrega: diasPrevistaEntrega,
                vendedor: vendedorSelecionado,
                metodos_pagamento: metodosPagamentosSelecionados,
                // condicao_pagamento: condicaoPagamentoSelecionada,
                valor_desconto_geral: valorDescontoGeral,
                modalidade_condicao: modalidadeCondicao,
                numero_parcelas: numeroParcelas,
                tipo_intervalo: tipoIntervalo,
                intervalo_parcelas: intervaloParcelas,
                intervalo_variavel: intervaloVariavel,
                intervalo_primeira_parcela: intervaloPrimeiraParcela,
                tipo_divisao: tipoDivisao,
                divisao_variavel: divisaoVariavel,
                frete_a_parte: freteAParte ? 1 : 0,
                conta_bancaria: contaBancariaSelecionada,

            }

            if (flag === 1) {
                cadastro.fornecedor = fornecedorSelecionado;
                cadastro.itens_pre_cotacao = itens;

                const dataPrevista = parse(dataInformada, 'dd/MM/yyyy', new Date());
                const dataISO = format(dataPrevista, 'yyyy-MM-dd');
                cadastro.data = dataISO;


            }

            if (dataEntrega && parse(dataEntrega, 'dd/MM/yyyy', new Date()) instanceof Date) {
                cadastro.data_prevista_entrega = format(parse(dataEntrega, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
            }


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));




            let response = null;
            if (flag === 0) {
                response = await api.put('/v1/protected/ordensdecompras/ordemdecompra/editarprecotacao/' + idPreCotacao + "/" + id_usuario_logado, cadastro,
                    { headers: headers });

            } else if (flag === 1) {
                response = await api.put('/v1/protected/ordensdecompras/ordemdecompra/salvarprecotacaostandalone/' + idOrdemC + "/" + id_usuario_logado, cadastro,
                    { headers: headers });
            }

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                if (flag === 0) {
                    alert("Orçamento Atualizado!");

                    // window.location.reload();
                    history.push({
                        pathname: "/gestao/administracao/ordensdecompras/editar/" + idOrdemCompra,
                    })
                } else if (flag === 1) {
                    history.push({
                        pathname: "/gestao/administracao/ordensdecompras/editar/" + idOrdemC,
                    })
                }

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }

    }






    function checkar() {


        try {

            // ✅ Validações antes de enviar
            if (!metodosPagamentosSelecionados || metodosPagamentosSelecionados.length === 0) {
                alert("Selecione o método de pagamento.");
                return false
            }

            if (!numeroParcelas || parseInt(numeroParcelas) <= 0) {
                alert("O número de parcelas deve ser maior que zero.");
                return false
            }

            const exigeContaBancaria = metodosPagamentosSelecionados.some(
                metodo => metodo.id_metodo_pagamento === 1 || metodo.id_metodo_pagamento === 2
            );

            if (exigeContaBancaria) {
                if (!contaBancariaSelecionada || contaBancariaSelecionada === "") {
                    alert("Selecione uma conta bancária para o método de pagamento escolhido");
                    return false
                }
            }

            console.log("cadastrar chamado");
            const cadastro = {

                observacoes: observacoes,
                valor_frete: valorFrete,
                dias_prevista_entrega: diasPrevistaEntrega,
                vendedor: vendedorSelecionado,
                metodos_pagamento: metodosPagamentosSelecionados,
                condicao_pagamento: condicaoPagamentoSelecionada,
                modalidade_condicao: modalidadeCondicao,
                numero_parcelas: numeroParcelas,
                tipo_intervalo: tipoIntervalo,
                intervalo_parcelas: intervaloParcelas,
                intervalo_variavel: intervaloVariavel,
                intervalo_primeira_parcela: intervaloPrimeiraParcela,
                tipo_divisao: tipoDivisao,
                divisao_variavel: divisaoVariavel,
                frete_a_parte: freteAParte ? 1 : 0,
                conta_bancaria: contaBancariaSelecionada,

            }

            if (dataEntrega && parse(dataEntrega, 'dd/MM/yyyy', new Date()) instanceof Date) {
                cadastro.data_prevista_entrega = format(parse(dataEntrega, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
            }

            return true;



        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            return false;

        }

    }


    useImperativeHandle(ref, () => ({
        atualizar: atualizar,
        checkar: checkar
    }));

    async function handleClickRemocao(event, cellValues) {
        const id_remover = cellValues.row.id_item_ordem_compra;

        if (flag === 0) {
            try {
                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                };

                const id_usuario_logado = parseInt(Cookies.get("id_usuario"));

                const response = await api.delete(
                    `/v1/protected/ordensdecompras/ordemdecompra/editarprecotacao/${idPreCotacao}/${id_usuario_logado}/removeritem/${id_remover}`,
                    { headers: headers }
                );

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {
                    alert("Removido!");
                    listarInformacoes();
                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");
                }

            } catch (_err) {
                console.log("erro ao remover: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } else {
            // 🔹 Remover apenas do array local
            setItens((prevItens) => {
                const novosItens = prevItens.filter(
                    (item) => item.id_item_ordem_compra !== id_remover
                );

                // Chama o recalculo após remover
                recalcularStandAlone(novosItens);

                return novosItens;
            });
        }
    }

    function returnDescricaoInsumo(insumo) {
        for (const variacao of insumo.variacoes) {
            if (variacao.id_fornecedor === preCotacao.fornecedor.id_fornecedor) {
                // Se encontrar uma correspondência, retorna a descrição dessa variação com "Variação" em negrito
                return <span><strong>Variação:</strong> {variacao.descricao}</span>;
            }
        }

        // Se não houver correspondência, retorna a descrição principal do insumo
        return insumo.descricao;
    }


    function returnDescricaoInsumoLocal(insumo) {
        insumo = insumo.insumo;
        for (const variacao of insumo.variacoes) {
            if (variacao.id_fornecedor === preCotacao.fornecedor.id_fornecedor) {
                // Se encontrar uma correspondência, retorna a descrição dessa variação com "Variação" em negrito
                return <span><strong>Variação:</strong> {variacao.descricao}</span>;
            }
        }

        // Se não houver correspondência, retorna a descrição principal do insumo
        return insumo.descricao;
    }



    const [openDialogEditarCotacao, setOpenDialogEditarCotacao] = useState(false);
    const [idCotacao, setIdCotacao] = useState(0);

    function handleCloseEditarCotacao(event, cellValues) {

        setIdCotacao(0);
        setOpenDialogEditarCotacao(false);
        listarInformacoes();
    };


    function handleClickEditarCotacao(event, cellValues) {

        //  var id = cellValues.row.cotacao.id_cotacao;
        //  var url = "/gestao/operacional/almoxarifado/cotacoes/editarcotacao/" + id;
        //  window.open(url, '_blank');
        setIdCotacao(cellValues.row.cotacao.id_cotacao);
        setOpenDialogEditarCotacao(true);
    };



    const handleAtualizarValorUnitario = async (cellValues) => {
        setOpenAtualizando(true);

        const id_cotacao = cellValues.row.cotacao.id_cotacao;
        console.log("Novo valor: " + editingValue);
        const cadastro = {
            valor_unitario: editingValue,

        };
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        const response = await api.put('/v1/protected/almoxarifado/cotacoes/atualizarvalorunitario/' + id_cotacao, cadastro,
            { headers: headers });

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {
            recalcular();
        } else {
            alert("Erro de Conexão, tente novamente mais tarde");

        }
        setOpenAtualizando(false);


    };

    const [editingValue, setEditingValue] = useState(0);
    const handleInputChange = (event) => {
        setEditingValue(event.target.value);
    };


    const [editingDescontoValue, setEditingDescontoValue] = useState(0);
    const handleInputChangeDesconto = (event) => {
        setEditingDescontoValue(event.target.value);
    };




    const handleAtualizarValorDescontoUnitario = async (cellValues) => {
        setOpenAtualizando(true);

        const id_cotacao = cellValues.row.cotacao.id_cotacao;

        const valor_unitario = cellValues.row.cotacao?.valor_unitario || 0;

        if (valor_unitario <= 0) {
            alert("Defina primeiro o valor unitario do item!");
            return;
        }

        if (editingDescontoValue > valor_unitario) {
            alert("Valor do desconto não pode ser superior ao valor do item");
            return;
        }

        console.log("Novo valor: " + editingDescontoValue);
        const cadastro = {
            valor_desconto: editingDescontoValue,

        };
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        const response = await api.put('/v1/protected/almoxarifado/cotacoes/atualizarvalordescontounitario/' + id_cotacao, cadastro,
            { headers: headers });

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {
            recalcular();
        } else {
            alert("Erro de Conexão, tente novamente mais tarde");

        }
        setOpenAtualizando(false);


    };




    const handleAtualizarCodigoFornecedor = async (cellValues) => {
        setOpenAtualizando(true);

        const id_cotacao = cellValues.row.cotacao.id_cotacao;
        console.log("Novo valor: " + codeEditingValue);
        const cadastro = {
            codigo_interno_fornecedor: codeEditingValue,

        };
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        const response = await api.put('/v1/protected/almoxarifado/cotacoes/atualizarcodigofornecedor/' + id_cotacao, cadastro,
            { headers: headers });

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {
        } else {
            alert("Erro de Conexão, tente novamente mais tarde");

        }
        setOpenAtualizando(false);

    };

    const [codeEditingValue, setCodeEditingValue] = useState('NAN');
    const handleInputCodeEditingChange = (event) => {
        setCodeEditingValue(event.target.value);
    };





    const handleAtualizarUnidadeFornecedor = async (cellValues) => {

        setOpenAtualizando(true);
        const id_cotacao = cellValues.row.cotacao.id_cotacao;
        console.log("Novo valor: " + unidadeEditingValue);
        const cadastro = {
            unidade: unidadeEditingValue,

        };
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        const response = await api.put('/v1/protected/almoxarifado/cotacoes/atualizarunidade/' + id_cotacao, cadastro,
            { headers: headers });

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {
        } else {
            alert("Erro de Conexão, tente novamente mais tarde");

        }
        setOpenAtualizando(false);

    };


    const [quantidadeEditingValue, setQuantidadeEditingValue] = useState(0);
    const handleInputQuantidadeChange = (event) => {
        setQuantidadeEditingValue(event.target.value);
    };

    const handleAtualizarQuantidade = async (cellValues) => {

        setOpenAtualizando(true);
        const id_item_ordem_compra = cellValues.row.id_item_ordem_compra;
        console.log("Novo valor: " + quantidadeEditingValue);
        const cadastro = {
            quantidade: quantidadeEditingValue,

        };
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        }
        const response = await api.put('/v1/protected/almoxarifado/itemordemcompra/atualizarquantidade/' + id_item_ordem_compra, cadastro,
            { headers: headers });

        const cadastro_salvo = response.data;
        if (cadastro_salvo) {
            recalcular();
        } else {
            alert("Erro de Conexão, tente novamente mais tarde");

        }
        setOpenAtualizando(false);

    };


    const [unidadeEditingValue, setUnidadeEditingValue] = useState('NAN');
    const handleInputUnidadeEditingChange = (event) => {
        setUnidadeEditingValue(event.target.value);
    };


    async function baixarArquivo(caminho) {
        try {
            const token = Cookies.get('token');
            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.post("/v1/protected/ordensdecompras/precotacao/baixaranexo", { caminho: encodeURIComponent(caminho) }, {
                headers: headers,
                responseType: 'arraybuffer',  // Indica que a resposta é um array de bytes
            });


            const extensao = caminho.split('.').pop().toLowerCase(); // Obtém a última parte do caminho após o último ponto e converte para minúsculas


            // Determina o tipo de mídia com base na extensão do arquivo
            let mediaType = 'application/octet-stream'; // Define um tipo padrão
            switch (extensao) {
                case 'pdf':
                    mediaType = 'application/pdf';
                    break;
                case 'doc':
                    mediaType = 'application/msword';
                    break;
                case 'docx':
                    mediaType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    break;
                case 'xls':
                    mediaType = 'application/vnd.ms-excel';
                    break;
                case 'xlsx':
                    mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    break;
                // Adicione outros tipos de arquivo conforme necessário
            }

            const blob = new Blob([response.data], { type: mediaType });

            // Cria uma URL do blob
            const blobUrl = URL.createObjectURL(blob);

            // Obtém o nome do arquivo a partir do caminho
            const nomeArquivo = caminho.split('/').pop(); // Obtém a última parte do caminho após a última barra

            // Cria um link <a> temporário
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = nomeArquivo; // Define o nome do arquivo a ser baixado
            link.click(); // Simula um clique no link para iniciar o download
        } catch (error) {
            // Trate os erros conforme necessário
            console.log("Erro ao baixar o arquivo: " + error);
        }
    }



    const [contextMenu, setContextMenu] = useState(null);
    const [insumoAVariar, setInsumoAVariar] = useState(null);


    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => {
        setContextMenu(null);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };



    function returnDescricaoBanco(ib) {

        var texto = "Identificação: " + ib.identificacao +
            "\nTitular: " + ib.titular +
            "\nBanco: " + ib.banco +
            "\nAgência: " + ib.agencia +
            "\nConta: " + ib.conta +
            "\nDescrição: " + ib.descricao +
            "\nPix: " + ib.tipo_chave_1 + "=" + ib.chave_1;
        return texto;


    }



    const [insumos, setInsumos] = useState([]);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);

    const [textoBusca, setTextoBusca] = useState("");

    useEffect(() => {

        if (textoBusca.length < 3) {
            return; // não busca com menos de 3 chars
        }

        const delayDebounce = setTimeout(() => {
            buscarInsumo(textoBusca);
        }, 250);

        return () => clearTimeout(delayDebounce);

    }, [textoBusca]);

    async function buscarInsumo(descricao) {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidopordescricao?descricao_busca=${descricao}`,
                { headers }
            );

            setInsumos(response.data);

        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }

    const handleSetInsumoSelecionado = (insumoSelecionado) => {
        if (!insumoSelecionado) return;

        setInsumoSelecionado(insumoSelecionado);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [insumosFiltrados, setInsumosFiltrados] = useState([]);


    const columnsDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 80,
            renderCell: (cellValues) => (

                <div>
                    <IconButton onClick={(event) => handleClickRemocao(event, cellValues)}>
                        <Delete />
                    </IconButton>
                    {flag === 0 && (
                        <IconButton onClick={(event) => handleClickEditarCotacao(event, cellValues)}>
                            <EditIcon />
                        </IconButton>
                    )}
                </div>

            ),
        },
        {
            headerName: 'ID',
            field: 'id_item_ordem_compra',
            width: 50,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Cód Fornecedor',
            field: 'codigo_interno_fornecedor',
            width: 100,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const code = cellValues.row.cotacao?.codigo_interno_fornecedor || 'NAN';
                return (
                    <TextField
                        defaultValue={code}
                        onBlur={(event) => {
                            if (flag === 0) {
                                handleAtualizarCodigoFornecedor(cellValues);
                            } else {
                                const novoCodigo = event.target.value;
                                setItens((prev) => {
                                    const novos = prev.map((item) =>
                                        item.id_item_ordem_compra === cellValues.row.id_item_ordem_compra
                                            ? {
                                                ...item,
                                                cotacao: {
                                                    ...item.cotacao,
                                                    codigo_interno_fornecedor: novoCodigo
                                                }
                                            }
                                            : item
                                    );
                                    recalcularStandAlone(novos);
                                    return novos;
                                });
                            }
                        }}
                        onFocus={() => setCodeEditingValue(code)}
                        onChange={handleInputCodeEditingChange}
                        variant="outlined"
                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                    />
                );
            },
        },
        {
            headerName: 'Insumo',
            field: 'cotacao',
            width: 400,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const row = cellValues.row;

                // 🔹 LINHAS NORMAIS
                const insumo = row.insumo;
                const cotacao = row.cotacao;

                let textoComQuebraDeLinha =
                    "Descrição Principal: " + insumo.descricao + "\n\n";

                if (insumo.variacoes && insumo.variacoes.length > 0) {
                    textoComQuebraDeLinha += insumo.variacoes
                        .filter(v => v.id_fornecedor !== cotacao.fornecedor.id_fornecedor)
                        .map((v, i) =>
                            `Fornecedor: ${v.nome_amigavel_fornecedor} Variação: ${v.descricao}`
                        )
                        .join('\n');
                }

                return (
                    <Tooltip
                        title={
                            <div style={{ backgroundColor: 'white', color: 'black', border: '2px solid black', padding: 8 }}>
                                {textoComQuebraDeLinha.split('\n').map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        <br />
                                    </React.Fragment>
                                ))}
                            </div>
                        }
                        placement="top"
                        arrow
                    >
                        <span>{returnDescricaoInsumo(insumo)}</span>
                    </Tooltip>
                );




            },
        },
        {
            headerName: 'Qtd',
            field: 'quantidade',
            width: 80,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const quantidade = cellValues.row.quantidade;
                return (
                    <TextField
                        defaultValue={quantidade}
                        onBlur={(event) => {
                            if (flag === 0) {
                                handleAtualizarQuantidade(cellValues);
                            } else {
                                const novaQtd = parseFloat(event.target.value) || 0;
                                setItens((prev) => {
                                    const novos = prev.map((item) =>
                                        item.id_item_ordem_compra === cellValues.row.id_item_ordem_compra
                                            ? { ...item, quantidade: novaQtd }
                                            : item
                                    );
                                    recalcularStandAlone(novos);
                                    return novos;
                                });
                            }
                        }}
                        onFocus={() => setQuantidadeEditingValue(quantidade)}
                        onChange={handleInputQuantidadeChange}
                        variant="outlined"
                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                    />
                );
            },
        },
        {
            headerName: 'Unidade',
            field: 'unidade',
            width: 80,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const unidade = cellValues.row.cotacao?.unidade || 'NAN';
                return (
                    <TextField
                        defaultValue={unidade}
                        onBlur={(event) => {
                            if (flag === 0) {
                                handleAtualizarUnidadeFornecedor(cellValues);
                            } else {
                                const novaUnidade = event.target.value;
                                setItens((prev) => {
                                    const novos = prev.map((item) =>
                                        item.id_item_ordem_compra === cellValues.row.id_item_ordem_compra
                                            ? {
                                                ...item,
                                                cotacao: { ...item.cotacao, unidade: novaUnidade }
                                            }
                                            : item
                                    );
                                    recalcularStandAlone(novos);
                                    return novos;
                                });
                            }
                        }}
                        onFocus={() => setUnidadeEditingValue(unidade)}
                        onChange={handleInputUnidadeEditingChange}
                        variant="outlined"
                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                    />
                );
            },
        },
        {
            headerName: 'Valor Uni.',
            field: 'valor_unitario',
            width: 100,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const valor_unitario = cellValues.row.cotacao?.valor_unitario || 0;
                return (
                    <TextField
                        defaultValue={currencyFormatter.format(valor_unitario)}
                        onBlur={(event) => {
                            const novoValor = parseFloat(event.target.value.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
                            if (flag === 0) {
                                handleAtualizarValorUnitario(cellValues);
                            } else {
                                setItens((prev) => {
                                    const novos = prev.map((item) =>
                                        item.id_item_ordem_compra === cellValues.row.id_item_ordem_compra
                                            ? {
                                                ...item,
                                                cotacao: { ...item.cotacao, valor_unitario: novoValor }
                                            }
                                            : item
                                    );
                                    recalcularStandAlone(novos);
                                    return novos;
                                });
                            }
                        }}
                        onFocus={() => setEditingValue(valor_unitario)}
                        onChange={handleInputChange}
                        variant="outlined"
                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                    />
                );
            },
        },
        {
            headerName: 'Desconto',
            field: 'valor_desconto',
            width: 100,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const valor_desconto = cellValues.row.cotacao?.valor_desconto || 0;
                return (
                    <TextField
                        defaultValue={currencyFormatter.format(valor_desconto)}
                        onBlur={(event) => {
                            const novoDesconto = parseFloat(event.target.value.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
                            if (flag === 0) {
                                handleAtualizarValorDescontoUnitario(cellValues);
                            } else {
                                setItens((prev) => {
                                    const novos = prev.map((item) =>
                                        item.id_item_ordem_compra === cellValues.row.id_item_ordem_compra
                                            ? {
                                                ...item,
                                                cotacao: { ...item.cotacao, valor_desconto: novoDesconto }
                                            }
                                            : item
                                    );
                                    recalcularStandAlone(novos);
                                    return novos;
                                });
                            }
                        }}
                        onFocus={() => setEditingDescontoValue(valor_desconto)}
                        onChange={handleInputChangeDesconto}
                        variant="outlined"
                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                    />
                );
            },
        },
        {
            headerName: 'Valor do Item com Desc.',
            width: 140,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const valor_desconto = cellValues.row.cotacao?.valor_desconto || 0;
                const valor_unitario = cellValues.row.cotacao?.valor_unitario || 0;
                return (
                    <TextField
                        value={currencyFormatter.format(valor_unitario - valor_desconto)}
                        InputProps={{ readOnly: true, style: { color: isDark ? 'white' : 'black' } }}
                        variant="outlined"
                    />
                );
            },
        },
        {
            headerName: 'Valor Total',
            field: 'valor_total',
            width: 120,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const valor_unitario = cellValues.row.cotacao?.valor_unitario || 0;
                const desconto = cellValues.row.cotacao?.valor_desconto || 0;
                const quantidade = cellValues.row.quantidade || 0;
                const total = quantidade * (valor_unitario - desconto);
                return <span>{currencyFormatter.format(total)}</span>;
            },
        },
    ];




    const [openNovoItem, setOpenNovoItem] = useState(false);


    const handleNovoItem = () => {
        setOpenNovoItem(true);
    }

    const handleCloseNovoItem = () => {
        setOpenNovoItem(false);
    }

    const [quantidade, setQuantidade] = useState(0);




    async function adicionarItem() {
        if (flag === 0) {
            if (!insumoSelecionado) {
                alert("Selecione o Insumo");
                return;
            }




            try {

                console.log("cadastrar chamado");
                const cadastro = {
                    quantidade: quantidade,
                    insumo: insumoSelecionado.insumo,

                }

                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                }

                const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


                const response = await api.put("/v1/protected/ordensdecompras/ordemdecompra/editarprecotacao/" + idPreCotacao + "/" + id_usuario_logado + "/inseriritem", cadastro,
                    { headers: headers });

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {
                    setQuantidade(0);
                    setInsumoSelecionado(null);
                    setTextoBusca('');
                    recalcular();
                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");

                }


            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");

            }

        } else if (flag == 1) {


            if (!insumoSelecionado) {
                alert("Selecione o Insumo");

                return;
            }

            if (quantidade <= 0) {
                alert("Quantidade deve ser maior que 0");

                return;
            }


            try {
                console.log("cadastrar chamado");

                setItens((prevItens) => {
                    const novoId = prevItens.length + 1; // gera ID baseado no tamanho atual
                    const cadastro = {
                        id_item_ordem_compra: novoId,
                        quantidade: quantidade,
                        insumo: insumoSelecionado.insumo,
                        id_insumo: insumoSelecionado.insumo.id_insumo,

                    };

                    setQuantidade(0);
                    setInsumoSelecionado(null);
                    setTextoBusca('');
                    return [...prevItens, cadastro];

                });

            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");
            }

        }

    }






    function returnDescricaoInsumoSimplificada(insumo) {


        var texto =


            "Descrição: " + insumo.descricao;
        return texto;
    }


    const columnsItensDataGrid = [

        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 2,
            width: 350,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const insumo = params.row.insumo;
                let descricao = returnDescricaoInsumoSimplificada(insumo);
                descricao = descricao.replace(/<br\s*\/?>/gi, '\n');
                return <div style={{ whiteSpace: 'pre-line' }}>{descricao}</div>;
            },
        },

        {
            headerName: 'Qtd Pedida',
            field: 'quantidade',
            id: 3,
            width: 130,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Qtd Reservada',
            field: 'quantidade_reservada',
            id: 4,
            width: 130,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Qtd a Comprar',
            field: 'quantidade_a_comprar',
            id: 5,
            width: 130,
            headerClassName: 'cabecalho_azul',
        },

        {
            headerName: 'Observações',
            field: 'observacoes',
            id: 4,
            width: 200,
            headerClassName: 'cabecalho_azul',
        },

    ];

    const [arrowRef, setArrowRef] = useState(null);

    const handleArrowRef = (node) => {
        setArrowRef(node);
    };




    const CustomDialog = ({ insumo }) => {
        const [descricao, setDescricao] = useState('');



        const handleDescricaoChange = (event) => {
            setDescricao(event.target.value);
        };

        async function salvarVariacao() {


            console.log("id do insumo a variar: " + insumo.id_insumo);

            var nome = preCotacao.fornecedor.tipo_fornecedor === 0 ? (preCotacao.fornecedor.nome + " " + preCotacao.fornecedor.sobrenome) :
                (preCotacao.fornecedor.nome_fantasia);
            //  return null;
            try {

                console.log("cadastrar chamado");
                const cadastro_variacao = {

                    descricao: descricao,
                    id_fornecedor: preCotacao.fornecedor.id_fornecedor,
                    nome_amigavel_fornecedor: nome,


                }



                const headers = {
                    'Authorization': 'Bearer ' + Cookies.get("token")
                }

                const response = await api.post('/v1/protected/almoxarifado/insumos/' + insumo.id_insumo + "/cadastrarvariacao", cadastro_variacao,
                    { headers: headers });

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {
                    alert("Variação Cadastrada!");
                    closeModal();

                    listarInformacoes();


                } else {
                    alert("Erro de Conexão, tente novamente mais tarde");
                }


            } catch (_err) {
                console.log("erro ao cadastrar: " + _err);
                alert("Erro de Conexão, tente novamente mais tarde");

            }



        }

        return (

            <Dialog open={isOpen} onClose={closeModal} PaperProps={{ style: { maxWidth: '600px', minWidth: '300px', backgroundColor: isDark ? '#1e1e1e' : 'white', color: isDark ? 'white' : 'black' } }}>
                <DialogTitle>Nova Variação de Insumo</DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} style={{ paddingTop: 20 }}>
                            <TextField
                                label="Descrição"
                                variant="outlined"
                                fullWidth
                                value={descricao}
                                onChange={handleDescricaoChange}
                                multiline
                                minRows={2}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={salvarVariacao} variant="contained" color="primary">
                                Criar Variação
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        );
    };


    const handleAdicionarMetodoPagamento = (event, newValue) => {
        // Verifica se o valor selecionado já está na lista
        const valoresSelecionados = Array.isArray(newValue) ? newValue : [newValue];
        const novosSolicitantes = valoresSelecionados.filter(
            (opcao) => !metodosPagamentosSelecionados.some((selecionado) => selecionado.id_metodo_pagamento === opcao.id_metodo_pagamento)
        );

        setMetodosPagamentosSelecionados([...metodosPagamentosSelecionados, ...novosSolicitantes]);
    };


    const handleRemoverMetodoPagamento = (event, metodoRemovido) => {
        const novosMetodos = metodosPagamentosSelecionados.filter(
            (metodo) => metodo.id_metodo_pagamento !== metodoRemovido.id_metodo_pagamento
        );
        setMetodosPagamentosSelecionados(novosMetodos);
    };

    function returnDescricaoMetodoPagamento(metodo) {
        var texto = "ID_METODO: " + metodo.id_metodo_pagamento + "\nNome: " + metodo.nome +
            "\nCodigo: " + metodo.codigo + "\nSigla: " + metodo.sigla + "\nDescrição: " + metodo.descricao;
        return texto;
    }


    const handleValorFrete = (v) => {



        setParametrosValores(prevState => ({
            ...prevState,
            valorTotal: (prevState.valorTotal - (valorFrete || 0) + Number(v))
        }));

        setValorFrete(v);
    };


    const handleDescontoGeral = (v) => {
        setParametrosValores(prevState => ({
            ...prevState,
            valorTotal: prevState.valorTotal - (Number(v) - (valorDescontoGeral || 0))
        }));

        setValorDescontoGeral(v);
        setParametrosValores(prevState => ({ ...prevState, 'valorDescontoGeral': v }))

    };


    const handleAdicionarCondicaoPagamento = (event, newValue) => {
        // Verifica se o valor selecionado já está na lista
        setCondicaoPagamentoSelecionada(newValue);
    };


    function returnDescricaoCodicaoPagamento(condicao) {
        var texto = "ID_CONDICAO: " + condicao.id_condicao_pagamento + "\nNome: " + condicao.nome +
            "\nDescrição: " + condicao.descricao +
            "\nNúmero de Parcelas: " + condicao.numero_parcelas + " parcelas" +
            "\nTipo Intervalo de Parcelas: " + (condicao.tipo_intervalo === 0 ? " Fixo" : "Variavel") +
            "\nIntervalo de Parcelas:" + (condicao.tipo_intervalo === 0 ? ("parcelas a cada " + condicao.intervalo_parcelas + " dias") : (condicao.intervalo_variavel + " dias")) +
            "\nPrimeira parcela para: " + (condicao.intervalo_primeira_parcela === 0 ? " Ato da Compra" : "Em " + condicao.intervalo_primeira_parcela + " dias") +
            "\nTipo Divisão de Valores: " + (condicao.divisao_variavel === 0 ? "Parcelas com valores iguais" : condicao.divisao_variavel);
        return texto;
    }

    return (
        <ThemeProvider theme={theme}>
            <ThemeProviderV4 theme={themeV4}>
                <CssBaseline />
                <CssBaselineV4 />
                <div style={{ backgroundColor: isDark ? '#121212' : '#ffffff', minHeight: '100vh', color: isDark ? 'white' : 'black' }}>
                    {flag === 0 &&
                        (<NavegadorGestao
                            Gestao={true}
                            OrdensCompras={true}
                            corFundo={isDark ? '#121212' : 'white'}
                            travado={true}
                            corTexto={isDark ? 'white' : 'black'}
                            darkMode={isDark}
                        />)
                    }
                    <div style={{ paddingTop: flag === 0 ? 80 : 5, padding: 10 }} >
                        {loading
                            ?
                            <div></div>

                            :

                            <React.Fragment >
                                <Grid
                                    style={{ backgroundColor: isDark ? '#121212' : 'white', width: '100%', alignItems: 'center', }}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}
                                        style={{ marginTop: 5 }}
                                    >

                                        {flag === 0 && (
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-start"
                                                align="flex-start"
                                                item xs={12}
                                                style={{ padding: 5 }}
                                            >

                                                <a href="/gestao/administracao/ordensdecompras/listar" style={{ fontSize: 14, color: isDark ? 'white' : 'black', marginRight: '5px' }}>{"Ordens de Compras"}</a>
                                                <span style={{ fontSize: 12, color: isDark ? 'white' : 'black' }}>-</span>
                                                <a href={"/gestao/administracao/ordensdecompras/editar/" + idOrdemCompra} style={{ fontSize: 14, color: isDark ? 'white' : 'black', marginLeft: '5px' }}>{"Ordem de Compra nº " + idOrdemCompra}</a>
                                            </Grid>
                                        )}


                                        <Box
                                            onClick={() => setAberto(prev => !prev)}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%',
                                                cursor: 'pointer',
                                                userSelect: 'none',
                                            }}
                                        >
                                            {/* Linha esquerda */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    borderBottom: '2px dotted #999',
                                                }}
                                            />

                                            {/* Texto central */}
                                            <Typography
                                                sx={{
                                                    px: 2,
                                                    fontWeight: 600,
                                                    color: '#999',
                                                    backgroundColor: '#121212', // 🔥 cor do fundo onde está o componente
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                Informações Iniciais
                                            </Typography>

                                            {/* Linha direita */}
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    borderBottom: '2px dotted #999',
                                                }}
                                            />

                                            {/* Seta */}
                                            <IconButton size="small" sx={{ ml: 1 }}>
                                                {aberto ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            </IconButton>
                                        </Box>


                                        {ordemCompra && aberto && (
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ padding: 5 }}
                                            >

                                                {ordemCompra?.ordem_servico ?
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        align="flex-start"
                                                        item xs={3}
                                                        style={{ marginTop: 5 }}
                                                    >
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{ backgroundColor: 'white', minHeight: '400px', minWidth: '1000px', border: '2px solid black' }}
                                                                >

                                                                    <Grid
                                                                        container
                                                                        direction="row"
                                                                        item xs={12}
                                                                        alignItems="center"
                                                                        justifyContent="center"
                                                                    >
                                                                        {
                                                                            ordemCompra.ordem_servico.itens_pre_requerimento &&
                                                                            <>
                                                                                <DataGrid
                                                                                    rows={ordemCompra.ordem_servico.itens_pre_requerimento}
                                                                                    getRowId={(row) => row.id_item_requerimento}
                                                                                    columns={columnsItensDataGrid}
                                                                                    disableColumnResize={false}
                                                                                    rowHeight={40}
                                                                                    sortModel={[
                                                                                        {
                                                                                            field: 'id_item_requerimento', // Campo pelo qual deseja ordenar
                                                                                            sort: 'asc', // 'asc' para ascendente, 'desc' para descendente
                                                                                        },
                                                                                    ]}
                                                                                />

                                                                            </>
                                                                        }



                                                                    </Grid>
                                                                </div>
                                                            }
                                                            placement="right"
                                                            arrow
                                                            style={{ backgroundColor: 'white' }}
                                                            sx={{ backgroundColor: 'white' }}
                                                        >
                                                            <IconButton aria-label="Requerimento de Itens">
                                                                <HelpOutlineIcon color='blue' />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                    :
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        align="flex-start"
                                                        item xs={3}
                                                        style={{ marginTop: 5 }}
                                                    >
                                                        <Tooltip
                                                            title={
                                                                <div
                                                                    style={{ backgroundColor: 'white', minHeight: '400px', minWidth: '1000px', border: '2px solid black' }}
                                                                >

                                                                    <Grid
                                                                        container
                                                                        direction="row"
                                                                        item xs={12}
                                                                        alignItems="center"
                                                                        justifyContent="center"
                                                                    >
                                                                        {
                                                                            ordemCompra.itens_pre_requerimento &&
                                                                            <>
                                                                                <DataGrid
                                                                                    rows={ordemCompra.itens_pre_requerimento}
                                                                                    getRowId={(row) => row.id_item_requerimento}
                                                                                    columns={columnsItensDataGrid}
                                                                                    disableColumnResize={false}
                                                                                    rowHeight={40}
                                                                                    sortModel={[
                                                                                        {
                                                                                            field: 'id_item_requerimento', // Campo pelo qual deseja ordenar
                                                                                            sort: 'asc', // 'asc' para ascendente, 'desc' para descendente
                                                                                        },
                                                                                    ]}
                                                                                />

                                                                            </>
                                                                        }



                                                                    </Grid>
                                                                </div>
                                                            }
                                                            placement="right"
                                                            arrow
                                                            style={{ backgroundColor: 'white' }}
                                                            sx={{ backgroundColor: 'white' }}
                                                        >
                                                            <IconButton aria-label="Requerimento de Itens">
                                                                <HelpOutlineIcon color='blue' />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>

                                                }

                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="flex-end"
                                                    align="flex-end"
                                                    item xs={8}
                                                    style={{ marginTop: 5 }}
                                                >

                                                    {preCotacao.caminho_arquivo_fornecedor ? (
                                                        <div>
                                                            <div
                                                                onClick={() => {
                                                                    baixarArquivo(preCotacao.caminho_arquivo_fornecedor);
                                                                }}
                                                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', margin: 0, width: '50px', height: '50px' }}
                                                            >
                                                                {/* Verifica a extensão do arquivo e exibe a miniatura ou o ícone correspondente */}
                                                                {preCotacao.caminho_arquivo_fornecedor.toLowerCase().endsWith('.pdf') ? (
                                                                    <img alt={'miniatura_pdf'} style={{ textAlign: 'center' }} src={miniatura_pdf} />
                                                                ) : (
                                                                    <img alt={'office'} style={{ textAlign: 'center' }} src={office} />
                                                                )}
                                                                <Typography align="center" variant="h7">
                                                                    Arquivo do Fornecedor
                                                                </Typography>
                                                            </div>
                                                            <SwapHorizIcon {...getRootArquivoProps1()} />
                                                        </div>
                                                    ) : (
                                                        <div {...getRootArquivoProps1()} style={dropzoneStyles}>
                                                            <input {...getInputArquivoProps1()} />
                                                            <Typography align="center" variant="h7">
                                                                Anexo
                                                            </Typography>
                                                        </div>
                                                    )}

                                                </Grid>



                                                <Grid
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={4}
                                                >

                                                    <Autocomplete
                                                        id="select-fornecedor"
                                                        options={[]}
                                                        disableCloseOnSelect
                                                        disabled
                                                        getOptionLabel={(fornecedor) => returnDescricaoFornecedor(fornecedor).replace(/<br \/>/g, '\n')}
                                                        value={fornecedorSelecionado}
                                                        getOptionSelected={(option, value) => true}
                                                        filterOptions={(options, { inputValue }) => {
                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                            return options.filter((fornecedor) => {
                                                                const cotacaoText = returnDescricaoFornecedor(fornecedor).toLowerCase();
                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label=" Fornecedor " multiline minRows={2} />
                                                        )}
                                                        renderOption={(option) => (
                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoFornecedor(option) }} />
                                                        )}
                                                    />

                                                </Grid>
                                                <Grid item xs={1} style={{ textAlign: "center" }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        startIcon={<GroupIcon />}
                                                        onClick={() =>
                                                            window.open(
                                                                "/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/" +
                                                                fornecedorSelecionado?.id_fornecedor,
                                                                "_blank",
                                                                "noopener,noreferrer"
                                                            )
                                                        }
                                                    >
                                                    </Button>
                                                </Grid>


                                                <Grid
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={3}
                                                >
                                                    <Autocomplete
                                                        id="select-vendedor"
                                                        options={fornecedorSelecionado.contatos}
                                                        disableCloseOnSelect
                                                        getOptionLabel={(vendedor) => returnDescricaoContato(vendedor).replace(/<br \/>/g, '\n')}
                                                        value={vendedorSelecionado}
                                                        onChange={(e, v) => setVendedorSelecionado(v)}
                                                        getOptionSelected={(option, value) => true}
                                                        filterOptions={(options, { inputValue }) => {
                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                            return options.filter((fornecedor) => {
                                                                const cotacaoText = returnDescricaoContato(fornecedor).toLowerCase();
                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label=" Vendedor " multiline minRows={2} />
                                                        )}
                                                        renderOption={(option) => (
                                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoContato(option) }} />
                                                        )}
                                                    />
                                                </Grid>

                                            </Grid>

                                        )}


                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                            spacing={1}
                                        >

                                            <Grid

                                                item xs={6}
                                            >

                                                <Autocomplete
                                                    id="select-insumo"
                                                    options={insumos}
                                                    disableCloseOnSelect
                                                    getOptionLabel={(insumo) =>
                                                        returnDescricaoInsumoGlobal(insumo).replace(/<br \/>/g, '\n')
                                                    }
                                                    value={insumoSelecionado}

                                                    onChange={(e, v) => handleSetInsumoSelecionado(v)}

                                                    // 🔥 captura O TEXTO DIGITADO
                                                    onInputChange={(event, newInputValue) => {
                                                        setTextoBusca(newInputValue);
                                                    }}

                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((insumo) => {
                                                            const insumoText = returnDescricaoInsumoGlobal(insumo).toLowerCase();
                                                            return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                        });
                                                    }}

                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                            label="Insumo"
                                                            multiline
                                                            minRows={2}
                                                            inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        />
                                                    )}

                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoInsumoGlobal(option) }} />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid
                                                item xs={2}

                                            >
                                                <TextField
                                                    variant="standard"
                                                    name="quantidade"
                                                    label="Quantidade"
                                                    id="quantidade"
                                                    value={quantidade}
                                                    onChange={(e) => setQuantidade(e.target.value)}
                                                    fullWidth
                                                    inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                />
                                            </Grid>

                                            <Grid

                                                item xs={2}
                                            >
                                                <Button style={{ marginTop: 1 }}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={(ev) => adicionarItem()}
                                                > Adicionar Item  </Button>
                                            </Grid>
                                        </Grid>


                                        <Grid
                                            style={{ paddingTop: 5 }}
                                            container
                                            direction="row"
                                            item xs={12}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <div key={tabelaKey}  >
                                                <DataGrid
                                                    key={itens.length > 0 ? itens[0].id_item_ordem_compra : 'grid'}
                                                    pagination
                                                    checkboxSelection={false}
                                                    rows={itens}
                                                    getRowId={(row) => row.id_item_ordem_compra}
                                                    disableColumnResize={false}
                                                    onCellClick={handleCellClick}
                                                    onRowClick={handleRowClick}
                                                    components={{
                                                        Toolbar: CustomToolbar,
                                                    }}
                                                    columns={columnsDataGrid.map(column => ({
                                                        ...column,
                                                        disableColumnMenu: true // Desabilita o menu de opções da coluna
                                                    }))}
                                                    sx={{
                                                        backgroundColor: isDark ? '#1e1e1e' : 'white',
                                                        color: isDark ? 'white' : 'black',
                                                        '& .MuiDataGrid-cell': {
                                                            borderBottom: isDark ? '1px solid #333' : '1px solid #f0f0f0',
                                                        },
                                                        '& .MuiDataGrid-columnHeaders': {
                                                            backgroundColor: isDark ? '#333' : '#f5f5f5',
                                                            color: isDark ? 'white' : 'black',
                                                        },
                                                        '& .MuiDataGrid-footerContainer': {
                                                            backgroundColor: isDark ? '#1e1e1e' : 'white',
                                                            color: isDark ? 'white' : 'black',
                                                        },
                                                    }}
                                                />
                                            </div>


                                        </Grid>






                                        <Grid item xs={12}
                                            style={{ padding: 10 }}
                                            container
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="center"

                                        >

                                            <Grid item xs={4}
                                                style={{ padding: 10 }}

                                            >
                                                <TextField
                                                    variant="standard"
                                                    name="valorFrete"
                                                    label="Valor Do Frete"
                                                    required
                                                    id="valorFrete"
                                                    value={valorFrete}
                                                    onChange={(e) => handleValorFrete(e.target.value)}
                                                    fullWidth
                                                    rows={1}
                                                />
                                            </Grid>
                                            <Grid item xs={2}
                                                style={{ padding: 10 }}

                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={freteAParte}
                                                            onChange={() => setFreteAParte(!freteAParte)}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Frete a parte"
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid item xs={12}
                                            style={{ padding: 10 }}
                                            container
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="center"

                                        >

                                            <Grid item xs={4}
                                                style={{ padding: 10 }}

                                            >
                                                <TextField
                                                    variant="standard"
                                                    name="valorDescontoGeral"
                                                    label="Desconto Geral"
                                                    required
                                                    id="valorDescontoGeral"
                                                    value={valorDescontoGeral}
                                                    onChange={(e) => handleDescontoGeral(e.target.value)}
                                                    fullWidth
                                                    rows={1}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            item xs={12}
                                        >

                                            <Grid
                                                item xs={12}
                                            >
                                                <Typography variant="h6">
                                                    {"Valor Total dos Itens: " + currencyFormatter.format(parametrosValores.valorTotalItens)}
                                                </Typography>
                                                <Typography variant="h6">
                                                    {"Valor Total Descontos por Itens: " + currencyFormatter.format(parametrosValores.valorTotalDescontos)}
                                                </Typography>
                                                <Typography variant="h6">
                                                    {"Valor Total Itens com Descontos: " + currencyFormatter.format(parametrosValores.valorTotalItensComDescontos)}
                                                </Typography>

                                                <Typography variant="h6">
                                                    {"Desconto Geral: " + currencyFormatter.format(parametrosValores.valorDescontoGeral)}
                                                </Typography>


                                                <Typography variant="h6">
                                                    {"Valor Total IPI: " + currencyFormatter.format(parametrosValores.valorTotalIpi)}
                                                </Typography>
                                                <Typography variant="h6">
                                                    {"Valor Total ICMS: " + currencyFormatter.format(parametrosValores.valorTotalIcms)}
                                                </Typography>
                                                <Typography variant="h6">
                                                    {"Valor do Frete: " + currencyFormatter.format(valorFrete)}
                                                </Typography>
                                                <Typography variant="h6" style={{ paddingTop: 20 }}>
                                                    {"Valor Final: " + currencyFormatter.format(parametrosValores.valorTotal)}
                                                </Typography>

                                            </Grid>


                                        </Grid>




                                        <Grid item xs={12}
                                            style={{ padding: 5 }}
                                            container
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="center"

                                        >

                                            <Grid item xs={6}
                                                style={{ padding: 5 }}

                                            >
                                                <TextField
                                                    variant="standard"
                                                    name="diasPrevistaEntrega"
                                                    label="Prazo da Entrega"
                                                    id="diasPrevistaEntrega"
                                                    value={diasPrevistaEntrega}
                                                    onChange={(e) => setDiasPrevistaEntrega(e.target.value)}
                                                    fullWidth
                                                    inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                />
                                            </Grid>
                                        </Grid>


                                        <Grid item xs={12}
                                            style={{ padding: 5 }}
                                            container
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="center"

                                        >

                                            <Grid item xs={6}
                                                style={{ padding: 5 }}

                                            >
                                                <TextField
                                                    variant="standard"
                                                    name="dataEntrega"
                                                    label="Data da Entrega"
                                                    id="dataEntrega"
                                                    value={dataEntrega}
                                                    onChange={(e) => setDataEntrega(e.target.value)}
                                                    fullWidth
                                                    inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12}
                                            style={{ padding: 5 }}
                                            container
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="center"

                                        >

                                            <Grid item xs={6}
                                                style={{ padding: 5 }}

                                            >
                                                <TextField
                                                    variant="standard"
                                                    name="observacoes"
                                                    label="Observações"
                                                    required
                                                    id="observacoes"
                                                    value={observacoes}
                                                    onChange={(e) => setObservacoes(e.target.value)}
                                                    fullWidth
                                                    multiline
                                                    minRows={3}
                                                    inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                    InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                />
                                            </Grid>
                                        </Grid>



                                        <Typography variant="h6" style={{ marginTop: 5, color: isDark ? 'white' : 'black' }}>
                                            Atributos Financeiros
                                        </Typography>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}
                                            style={{ marginTop: 5 }}
                                        >
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={6}
                                            >

                                                <Autocomplete
                                                    id="select-metodos-pagamento"
                                                    options={metodosPagamento}
                                                    disableCloseOnSelect
                                                    multiple
                                                    fullWidth
                                                    getOptionLabel={(metodo) => returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                                    value={metodosPagamentosSelecionados}
                                                    onChange={handleAdicionarMetodoPagamento}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const inputKeywords = inputValue.toLowerCase().split(" ");
                                                        return options.filter((solicitante) => {
                                                            const cotacaoText = returnDescricaoMetodoPagamento(solicitante).toLowerCase();
                                                            return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                        });
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                            label=" Métodos de Pagamento "
                                                            multiline
                                                            rows={2}
                                                            inputProps={{ ...params.inputProps, style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        />
                                                    )}
                                                    renderOption={(option) => (
                                                        <div dangerouslySetInnerHTML={{ __html: returnDescricaoMetodoPagamento(option).replace(/\n/g, '<br>') }} />
                                                    )}
                                                    renderTags={(value, getTagProps) =>
                                                        value.map((metodo, index) => (
                                                            <Chip
                                                                label={metodo.nome}
                                                                {...getTagProps({ index })}
                                                                onDelete={(event) => handleRemoverMetodoPagamento(event, metodo)}
                                                                sx={{ color: isDark ? 'white' : 'black', backgroundColor: isDark ? '#333' : '#e0e0e0' }}
                                                            />
                                                        ))
                                                    }
                                                />
                                            </Grid>
                                        </Grid>


                                        <Box
                                            sx={{
                                                maxWidth: 900,
                                                mx: "auto", // centraliza horizontalmente
                                                p: 3,
                                                mt: 4,
                                                border: isDark ? "1px solid #444" : "1px solid #ccc",
                                                borderRadius: 2,
                                                boxShadow: 3,
                                                backgroundColor: isDark ? "#1e1e1e" : "#f9f9f9",
                                                color: isDark ? "white" : "black"
                                            }}
                                        >
                                            <Typography variant="h6" align="center" gutterBottom style={{ color: isDark ? 'white' : 'black' }}>
                                                Condições de Pagamento
                                            </Typography>

                                            <Grid container spacing={2}>
                                                {/* Modalidade */}
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel style={{ color: isDark ? 'white' : 'black' }}>Modalidade</InputLabel>
                                                        <Select
                                                            value={modalidadeCondicao}
                                                            onChange={(e) => setModalidadeCondicao(e.target.value)}
                                                            sx={{ color: isDark ? 'white' : 'black', '.MuiOutlinedInput-notchedOutline': { borderColor: isDark ? '#555' : '#ccc' } }}
                                                        >
                                                            <MenuItem value={0}>Antecipado - À vista</MenuItem>
                                                            <MenuItem value={1}>Após receber Nota Fiscal</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                {/* Tipo do Intervalo */}
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel style={{ color: isDark ? 'white' : 'black' }}>Tipo do Intervalo</InputLabel>
                                                        <Select
                                                            value={tipoIntervalo}
                                                            onChange={(e) => setTipoIntervalo(e.target.value)}
                                                            sx={{ color: isDark ? 'white' : 'black', '.MuiOutlinedInput-notchedOutline': { borderColor: isDark ? '#555' : '#ccc' } }}
                                                        >
                                                            <MenuItem value={0}>Fixo</MenuItem>
                                                            <MenuItem value={1}>Variável</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                {/* Número de Parcelas */}
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Nº de Parcelas"
                                                        value={numeroParcelas}
                                                        onChange={(e) => setNumeroParcelas(e.target.value.replace(/\D/g, ""))}
                                                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                    />
                                                </Grid>

                                                {/* Intervalo de Parcelas */}
                                                {tipoIntervalo === 0 && (
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            label="Intervalo (dias)"
                                                            value={intervaloParcelas}
                                                            onChange={(e) => setIntervaloParcelas(e.target.value.replace(/\D/g, ""))}
                                                            inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        />
                                                    </Grid>
                                                )}
                                                {tipoIntervalo === 1 && (
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            label="Intervalo Variável (dias)"
                                                            value={intervaloVariavel}
                                                            onChange={(e) => setIntervaloVariavel(e.target.value.replace(/[^\d,]/g, ""))}
                                                            inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        />
                                                    </Grid>
                                                )}

                                                {/* Intervalo da Primeira Parcela */}
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Primeira Parcela (dias)"
                                                        value={intervaloPrimeiraParcela}
                                                        onChange={(e) => setIntervaloPrimeiraParcela(e.target.value.replace(/\D/g, ""))}
                                                        inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                    />
                                                </Grid>

                                                {/* Tipo de Divisão */}
                                                <Grid item xs={12} sm={3}>
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel style={{ color: isDark ? 'white' : 'black' }}>Tipo de Divisão</InputLabel>
                                                        <Select
                                                            value={tipoDivisao}
                                                            onChange={(e) => setTipoDivisao(e.target.value)}
                                                            sx={{ color: isDark ? 'white' : 'black', '.MuiOutlinedInput-notchedOutline': { borderColor: isDark ? '#555' : '#ccc' } }}
                                                        >
                                                            <MenuItem value={0}>Igualitária</MenuItem>
                                                            <MenuItem value={1}>Variável</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                {/* Divisão Variável */}
                                                {tipoDivisao === 1 && (
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            label="Divisão (%)"
                                                            value={divisaoVariavel}
                                                            onChange={(e) => setDivisaoVariavel(e.target.value.replace(/[^\d,]/g, ""))}
                                                            inputProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                            InputLabelProps={{ style: { color: isDark ? 'white' : 'black' } }}
                                                        />
                                                    </Grid>
                                                )}

                                                {/* Tipo de Valor e Repetir Data */}
                                                <Grid item xs={12} sm={6} container alignItems="center" spacing={1}>
                                                    <Grid item>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={tipoValor === "total"}
                                                                    onChange={() => setTipoValor("total")}
                                                                    sx={{ color: isDark ? 'white' : 'default' }}
                                                                />
                                                            }
                                                            label="Total"
                                                            sx={{ color: isDark ? 'white' : 'black' }}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={tipoValor === "parcela"}
                                                                    onChange={() => setTipoValor("parcela")}
                                                                    sx={{ color: isDark ? 'white' : 'default' }}
                                                                />
                                                            }
                                                            label="Parcela"
                                                            sx={{ color: isDark ? 'white' : 'black' }}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={repetirData}
                                                                    onChange={(e) => setRepetirData(e.target.checked)}
                                                                    sx={{ color: isDark ? 'white' : 'default' }}
                                                                />
                                                            }
                                                            label="Repetir Data"
                                                            sx={{ color: isDark ? 'white' : 'black' }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* contabancaria */}
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={6}
                                            >
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={12}
                                                >


                                                    <Autocomplete
                                                        id="select-fornecedor-recebedor"
                                                        options={fornecedorSelecionado?.contas_bancarias || []}
                                                        fullWidth
                                                        style={{ fontSize: '14px' }}
                                                        getOptionLabel={(conta) => returnDescricaoBanco(conta).replace(/<br \/>/g, '\n')}
                                                        value={contaBancariaSelecionada}
                                                        onChange={(e, value) => setContaBancariaSelecionada(value)}
                                                        getOptionSelected={(option, value) => option.id_conta_bancaria === value?.id_conta_bancaria}
                                                        filterOptions={(options, { inputValue }) => {
                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                            return options.filter((solicitante) => {
                                                                const cotacaoText = returnDescricaoBanco(solicitante).toLowerCase();
                                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                style={{ fontSize: '14px' }}
                                                                InputProps={{ ...params.InputProps, style: { fontSize: '14px', color: isDark ? 'white' : 'black' } }}
                                                                InputLabelProps={{ style: { fontSize: '14px', color: isDark ? 'white' : 'black' } }}
                                                                label=" Conta Bancária do Recebedor "
                                                                multiline
                                                                minRows={2}
                                                            />
                                                        )}
                                                    />




                                                </Grid>
                                            </Grid>

                                        </Box>

                                        {/* Simulação de Pagamentos */}
                                        <Box
                                            sx={{
                                                maxWidth: 900,
                                                mx: "auto",
                                                p: 3,
                                                mt: 4,
                                                mb: 4,
                                                border: isDark ? "1px solid #444" : "1px solid #ccc",
                                                borderRadius: 2,
                                                boxShadow: 3,
                                                backgroundColor: isDark ? "#1e1e1e" : "#f9f9f9",
                                                color: isDark ? "white" : "black"
                                            }}
                                        >
                                            <Typography variant="h6" align="center" gutterBottom style={{ color: isDark ? 'white' : 'black' }}>
                                                Simulação de Pagamentos
                                            </Typography>

                                            {parcelasSimuladas.length > 0 ? (
                                                <Grid container spacing={1} sx={{ mt: 2 }}>
                                                    <Grid item xs={12}>
                                                        <Paper sx={{ p: 2, backgroundColor: isDark ? '#333' : '#fff', color: isDark ? 'white' : 'black' }}>
                                                            <Grid container spacing={2} sx={{ fontWeight: 'bold', borderBottom: isDark ? '1px solid #555' : '1px solid #ddd', pb: 1, mb: 1 }}>
                                                                <Grid item xs={2}>Parcela</Grid>
                                                                <Grid item xs={4}>Vencimento</Grid>
                                                                <Grid item xs={3}>Valor</Grid>
                                                                <Grid item xs={3}>Método</Grid>
                                                            </Grid>
                                                            {parcelasSimuladas.map((parcela, index) => (
                                                                <Grid container spacing={2} key={index} sx={{ py: 0.5, borderBottom: isDark ? '1px solid #444' : '1px solid #eee' }}>
                                                                    <Grid item xs={2}>{index + 1}ª</Grid>
                                                                    <Grid item xs={4}>{parcela.data_vencimento}</Grid>
                                                                    <Grid item xs={3}>{currencyFormatter.format(parcela.valor)}</Grid>
                                                                    <Grid item xs={3}>{parcela.metodo_pagamento?.nome || '-'}</Grid>
                                                                </Grid>
                                                            ))}
                                                            <Grid container spacing={2} sx={{ mt: 1, fontWeight: 'bold' }}>
                                                                <Grid item xs={6} textAlign="right">Total Simulado:</Grid>
                                                                <Grid item xs={3}>
                                                                    {currencyFormatter.format(parcelasSimuladas.reduce((acc, p) => acc + p.valor, 0))}
                                                                </Grid>
                                                            </Grid>
                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                <Typography variant="body2" align="center" sx={{ color: isDark ? '#aaa' : '#666', mt: 2 }}>
                                                    Preencha as condições de pagamento para ver a simulação.
                                                </Typography>
                                            )}
                                        </Box>


                                        {
                                            ordemCompra &&
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="flex-end"
                                                alignItems="center"
                                                item xs={10}
                                            >
                                                <Button style={{ marginTop: 50 }}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={atualizar}
                                                > Atualizar </Button>
                                            </Grid>
                                        }


                                    </Grid>

                                </Grid>
                            </React.Fragment>
                        }

                    </div>

                    <Snackbar
                        open={openAtualizando}
                        autoHideDuration={1500}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    >
                        <MuiAlert elevation={6} variant="filled"  >
                            Atualizando...
                        </MuiAlert>
                    </Snackbar>
                    <Menu
                        open={contextMenu != null}
                        onClose={() => setContextMenu(null)}
                        anchorReference="anchorPosition"
                        anchorPosition={
                            contextMenu != null
                                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                : undefined
                        }
                    >
                        <MenuItem onClick={(e) => openModal()}>Definir Variação</MenuItem>
                    </Menu>


                    <CustomDialog insumo={insumoAVariar} />



                    <Dialog open={openDialogEditarCotacao} onClose={handleCloseEditarCotacao} PaperProps={{ style: { maxWidth: '600px', minWidth: '300px', backgroundColor: isDark ? '#1e1e1e' : 'white', color: isDark ? 'white' : 'black' } }}>
                        <DialogTitle>Editar Cotação</DialogTitle>
                        <DialogContent>
                            <Grid
                                direction={"row"}
                                item xs={12}
                                container
                                alignItems={'center'}
                                justifyContent={'center'}
                                spacing={3}
                            >
                                <EditarCotacao flagBack={11} idCotacao={idCotacao} handleCloseEditarCotacao={handleCloseEditarCotacao} />

                            </Grid>

                        </DialogContent>
                    </Dialog>


                    {flag === 1 && (
                        <Dialog open={openNovoItem} onClose={handleCloseNovoItem} PaperProps={{ style: { maxWidth: '600px', minWidth: '500px', backgroundColor: isDark ? '#1e1e1e' : 'white', color: isDark ? 'white' : 'black' } }}>
                            <DialogTitle>Novo Item</DialogTitle>
                            <DialogContent>
                                <Grid
                                    direction={"row"}
                                    item xs={12}
                                    container
                                    alignItems={'center'}
                                    justifyContent={'center'}
                                    spacing={3}
                                >
                                    < CadastrarNovoItemPreCotacaoStandalone idFornecedor={fornecedorSelecionado.id_fornecedor} handleCloseNovoItem={handleCloseNovoItem} setItens={setItens} />
                                </Grid>

                            </DialogContent>
                        </Dialog>
                    )}

                </div>
            </ThemeProviderV4>
        </ThemeProvider>
    );
});

export default EditarPreCotacao;
